import React from "react";
import logo from "../../assets/images/home/appLogo 1.png";
import pinplus from "../../assets/images/home/logoLight.png";
import pin1 from "../../assets/images/home/pin2.png";
import pin2 from "../../assets/images/home/pin3.png";

import  pinplusg  from '../../assets/images/home/mocks.png';
import "./HomePage.scss";

const HomePage = () => {
  return (
    <div className="homepage">
      {/* Hero Section */}
      <nav className="navbar">
        <img src={logo} alt="PinPlus Logo" className="app-logoNav" />
      </nav>
      <section className="hero">
        <div className="logo-container">
          <img src={pinplus} alt="PinPlus Logo" />
          {/* <h1>PinPlus</h1> */}
        </div>
        <p className="tagline">Discover & Share Your Travel Experiences!</p>
        <p className="tagline-description">
          Create location-based pins, share your reviews, photos, and videos,
          and <br /> explore hidden gems recommended by real travelers.
        </p>
        <div className="buttons">
          <button className="primary-btn">Get Started</button>
          <button className="secondary-btn">Explore Pins</button>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <h2>Why Choose PinPlus?</h2>
        <div className="feature-container">
          <img className="feature-image" src={pin2} alt="PinPlus Logo" />
          <div className="feature-list">
            <div className="feature-item">
              <h3> Create & Save Pins</h3>
              <p>
                Mark your favorite spots, add photos, videos, and detailed
                reviews.
              </p>
            </div>
            <div className="feature-item">
              <h3> Discover & Explore</h3>
              <p>Find the best places recommended by real people worldwide.</p>
            </div>
            <div className="feature-item">
              <h3>Social & Interactive</h3>
              <p>
                Follow travelers, chat with them, and leave remarks on their
                pins.
              </p>
            </div>
            <div className="feature-item">
              <h3> Personalized Experience</h3>
              <p>
                Get recommendations based on your interests and favorite
                locations.
              </p>
            </div>
          </div>
        </div>
        <div className="feature-container">
          <div className="feature-list">
            <div className="feature-item">
              <h3>Drop a Pin</h3>
              <p>Choose any location and create a pin.</p>
            </div>
            <div className="feature-item">
              <h3>Share Your Experience</h3>
              <p>Upload photos, videos, and reviews.</p>
            </div>
            <div className="feature-item">
              <h3>Engage with Others</h3>
              <p>Explore pins, leave remarks, and chat with travelers.</p>
            </div>
          </div>
          <img className="feature-image" src={pin1} alt="PinPlus Logo" />
        </div>
      </section>

      {/* Call to Action Section */}
      <section className="cta">
        <div>
          <h2>Get Started with PinPlus!</h2>
          <p>Join the Community & Start Pinning Today.</p>
          <div className="buttons">
            <button className="primary-btn">Download on the Play Store</button>
            <button className="secondary-btn">Download on the App Store</button>
          </div>
        </div>
        <img className="pinplusg" src={pinplusg} alt="PinPlus Logo" />
      </section>

      {/* Footer Section */}
      <footer className="footer">
        <p>&copy; {new Date().getFullYear()} PinPlus. All Rights Reserved.</p>
        <ul>
          <li>
            <a href="/privacy-policy">Privacy Policy</a>
          </li>
          {/* <li>
            <a href="/terms-of-service">Terms of Service</a>
          </li>
          <li>
            <a href="/contact">Contact Us</a>
          </li>
          <li>
            <a href="/faq">FAQs</a>
          </li> */}
        </ul>
      </footer>
    </div>
  );
};

export default HomePage;
